/* Note: The style constants are not moved to BaseRow, because it's tricky
 * to read data in style script and apply to animation */

/**
 * The time in seconds that the clipboard button will be faded in for.
 */
const CLIPBOARD_FADE_TIME = 0.3;
/**
 * The unicode "bullet" character: • for loading dots when waiting for
 * ChatGPT to return a response
 */
const DOT = '\u2022';

export { CLIPBOARD_FADE_TIME, DOT };
